import wixLocation from 'wix-location';
import wixWindow from 'wix-window';


$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
		$w('#mobileTest').show()
		.then(() => $w('#mobileTest').expand())
} 

});
let fadeOutOptions = {
	"duration": 100,
	"delay": 0
};
let fadeInOptions = {
	"duration": 300,
	"delay": 0
};

const validateEmailInput = (inputText) => {
	var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	if (inputText.match(mailformat)) return true;
	else return false;
}

// const showEmailInputWarning = () => {
// 	$w('#emailInputWarning').show('fade', fadeOutOptions);
// 	setTimeout(() => $w('#emailInputWarning').hide('fade', fadeOutOptions), 5000)
// }

export function button78_click(event) {
	//Add your code for this event here: 
	const email = $w('#input1').value;
	validateEmailInput(email) ? wixLocation.to(`https://info.wixanswers.com/unified_product_demo?email=${email}`) : showEmailInputWarning();
}


const showYotpoGalleryBox = () => {
	if ($w('#yotpoGalleryBox').isVisible) return;
	$w('#fiverrGalleryBtn, #wonderblyGalleryBtn').disable()
		.then($w('#fiverrGalleryBox, #wonderblyGalleryBox, #yotpoGalleryBox').hide('fade', fadeOutOptions))
		.then($w('#fiverrGalleryBtn, #wonderblyGalleryBtn').style.backgroundColor = '#F4F7FD')
		.then($w('#yotpoGalleryBox').show('fade', fadeInOptions))
		.then($w('#yotpoGalleryBtn').style.backgroundColor = '#FFFFFF')
		.then(setTimeout(() => $w('#fiverrGalleryBtn, #wonderblyGalleryBtn').enable(), 1000))
		.catch(err => console.log('somthing wrong: ' + err))
}
const showFiverrGalleryBox = () => {
	if ($w('#fiverrGalleryBox').isVisible) return;
	$w('#wonderblyGalleryBtn, #yotpoGalleryBtn').disable()
		.then($w('#yotpoGalleryBox, #wonderblyGalleryBox, #fiverrGalleryBox').hide('fade', fadeOutOptions))
		.then($w('#wonderblyGalleryBtn, #yotpoGalleryBtn').style.backgroundColor = '#F4F7FD')
		.then($w('#fiverrGalleryBox').show('fade', fadeInOptions))
		.then($w('#fiverrGalleryBtn').style.backgroundColor = '#FFFFFF')
		.then(setTimeout(() => $w('#wonderblyGalleryBtn, #yotpoGalleryBtn').enable(), 1000))
		.catch(err => console.log('somthing wrong: ' + err))

}
const showWonderblyGalleryBox = () => {
	if ($w('#wonderblyGalleryBox').isVisible) return;
	$w('#fiverrGalleryBtn, #yotpoGalleryBtn').disable()
		.then($w('#fiverrGalleryBox, #yotpoGalleryBox, #wonderblyGalleryBox').hide('fade', fadeOutOptions))
		.then($w('#fiverrGalleryBtn, #yotpoGalleryBtn').style.backgroundColor = '#F4F7FD')
		.then($w('#wonderblyGalleryBox').show('fade', fadeInOptions))
		.then($w('#wonderblyGalleryBtn').style.backgroundColor = '#FFFFFF')
		.then(setTimeout(() => $w('#fiverrGalleryBtn, #yotpoGalleryBtn').enable(), 1000))
		.catch(err => console.log('somthing wrong: ' + err))
}

export function yotpoGalleryBtn_click(event) {
	//Add your code for this event here: 
	showYotpoGalleryBox();
}

export function wonderblyGalleryBtn_click(event) {
	//Add your code for this event here: 
	showWonderblyGalleryBox();
}

export function fiverrGalleryBtn_click(event) {
	//Add your code for this event here: 
	showFiverrGalleryBox();
}



export function box1_click(event) {
	wixLocation.to('https://info.wixanswers.com/buyers-guide.html?_ga=2.253092170.2126139412.1604416810-186538437.1577202555');
}

export function box2_click(event) {
	wixLocation.to('https://www.wixanswers.com/post/customer-support-platforms-for-smbs?utm_source=website&utm_medium=homepage&utm_campaign=blog_promotion&utm_content=elevate-your-support-product-expert-teams');
}

export function box3_click(event) {
	wixLocation.to('https://app.wixanswers.com/assessment');
}


export function yotpoGalleryImgBtn_click(event) {
	showYotpoGalleryBox();
}

export function wonderblyGalleryImgBtn_click(event) {
	showWonderblyGalleryBox(); 
}


export function fiverrGalleryImgBtn_click(event) {
	showFiverrGalleryBox();
}